var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDeposites(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 12V15C18.5 16.3 15.366 18 11.5 18C7.634 18 4.5 16.3 4.5 15V12.5",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.79395 12.7583C5.65895 13.9063 8.33395 14.9833 11.4999 14.9833C15.3659 14.9833 18.4999 13.3773 18.4999 11.9973C18.4999 11.2223 17.5129 10.3733 15.9639 9.77734",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 6V9C15.5 10.3 12.366 12 8.5 12C4.634 12 1.5 10.3 1.5 9V6",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 8.984C12.366 8.984 15.5 7.378 15.5 5.998C15.5 4.617 12.366 3 8.5 3C4.634 3 1.5 4.617 1.5 5.998C1.5 7.378 4.634 8.984 8.5 8.984Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeposites);
export default __webpack_public_path__ + "static/media/deposites.aee7b700dc3f9bf5c895afd2df6e1ff8.svg";
export { ForwardRef as ReactComponent };